import client from '../../base-api';

const serviceURL = '/dashboard/site-support';

const dashboardSiteSupportService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },
}

export default dashboardSiteSupportService;